const OfferDescription = ({ props }) => {
    const { snippet } = props;

    if (!snippet) {
        return;
    }

    return <div class='l-ss-c-offer-description'>{snippet}</div>;
};

OfferDescription.props = {
    snippet: {
        type: String,
    },
};

export default OfferDescription;
